export var websiteWidth = 760;
export var websiteOuterWidth = 1023;
